const baseProps = {
  css: {},
};

export const setDefaultProps = (props = {}) => ({ ...baseProps, ...props});
